import {
  Users,
  Building2,
  FileText,
  Zap,
} from "lucide-react";

export const features = [
  {
    icon: Building2,
    title: "Vendor Registration",
    description:
      "Complete account setup with validation and product catalog management.",
    id: "feat-1",
  },
  {
    icon: Users,
    title: "Buyer Portal",
    description:
      "Streamlined registration with contact verification and requirement submission.",
    id: "feat-2",
  },
  {
    icon: FileText,
    title: "AI Parsing",
    description:
      "Natural language processing for buyer expectations and automated matching.",
    id: "feat-3",
  },
  {
    icon: Zap,
    title: "Smart Notifications",
    description:
      "Automated email alerts to shortlisted vendors based on buyer criteria.",
    id: "feat-4",
  },
];
